import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Divider,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import BoltIcon from "@mui/icons-material/Bolt";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Homeimages } from "../../assets";

/* ================= DATA ================= */

// ✅ Coaching (NORMAL CARDS)
const coachingServices = [
  {
    title: "Luxury Sales Coaching",
    desc: "Master the mindset, language, and presence that commands  premium fees and makes high value clients choose you without hesitation.",
    tag: "PREMIUM TIER",
  },
  {
    title: "High-Ticket Closing System",
    desc: "A proven, repeatable framework to move conversations from interest to commitment built for deals where a single close changes your year.",
    tag: "PROVEN SYSTEM",
  },
  // {
  //   title: "Private 1:1 Mentorship",
  //   desc: "Bring your real deals, real objections, and real challenges. Get direct, unfiltered strategy from someone who has navigated ₹Crore level rooms firsthand.",
  //   tag: "EXCLUSIVE ACCESS",
  // },
];

// ✅ Consulting (FLOW STEPS)
const consultingSteps = [
  { num: "01", title: "Strategy", desc: "Positioning, pricing, and market clarity" },
  { num: "02", title: "Demand Creation", desc: "Targeted outreach that attracts the right buyers" },
  { num: "03", title: "Lead Management", desc: "Structured pipeline with disciplined follow-ups" },
  { num: "04", title: "Channel Ecosystem", desc: "Aligned brokers and partners are driving deal flow" },
  { num: "05", title: "Sales Conversion", desc: "Guided conversations, negotiation, and closure control" },
  { num: "06", title: "Tracking & Optimization", desc: "Real-time visibility and continuous performance improvement" },
];

const LuxuryServices = () => {
  const [tab, setTab] = useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ position: "relative", minHeight: "90vh", color: "#fff", overflow: "hidden", }}>

      {/* BG */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,

          backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/lightcharminar.png")`,
          backgroundSize: "cover",
          backgroundPosition: "center",

          // ✅ THIS CREATES FIXED EFFECT INSIDE SECTION
          backgroundAttachment: {
            xs: "scroll", // ❌ mobile fix (important)
            md: "fixed",  // ✅ desktop parallax
          },

          zIndex: -2,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `
            linear-gradient(
              135deg,
              rgba(15,99,165,0.85),
              rgba(15,99,165,0.6)
            )
          `,
          zIndex: -1,
        }}
      />
      {/* ✨ GLOSS LIGHT */}
      <Box
        sx={{
          position: "absolute",
          top: "-20%",
          left: "-10%",
          width: "600px",
          height: "600px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.25), transparent 70%)",
          filter: "blur(80px)",
        }}
      />

      <Container maxWidth="xl" sx={{ py: 12, px: { xs: 2, md: 8 } }}>

        {/* HEADER */}
        <Box textAlign="center" mb={6}>
          <Typography variant="h3" fontWeight={600}
            sx={{
              color: '#fff'
            }}
          >
            Premium Services
          </Typography>
          <Typography sx={{ opacity: 0.85, mt: 2, color: '#fff' }}>
            Tailored solutions for high-ticket closures

          </Typography>
        </Box>

        {/* TABS */}
        <Box display="flex" justifyContent="center" mb={8}>

          <Box
            sx={{
              position: "relative",
              p: "6px",
              borderRadius: "40px",

              background: "rgba(255,255,255,0.08)",
              backdropFilter: "blur(14px)",
              border: "1px solid rgba(255,255,255,0.15)",

              boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
            }}
          >
            <Tabs
              value={tab}
              onChange={(e, v) => setTab(v)}
              TabIndicatorProps={{
                style: { display: "none" }, // ❌ remove default line
              }}
              sx={{
                minHeight: "auto",
              }}
            >
              {["Coaching", "Consulting"].map((label, index) => (
                <Tab
                  key={label}
                  label={label}
                  disableRipple
                  sx={{
                    minHeight: "auto",
                    px: 4,
                    py: 1.2,
                    borderRadius: "30px",
                    fontSize: "1.25rem",   // same as h6
                    fontWeight: 600,
                    textTransform: "none",
                    color: tab === index ? "#fff" : "rgba(255,255,255,0.6)",

                    transition: "all 0.4s ease",

                    // 🔥 ACTIVE TAB
                    background:
                      tab === index
                        ? "linear-gradient(135deg, #4fc3f7, #0288d1)"
                        : "transparent",

                    boxShadow:
                      tab === index
                        ? "0 8px 25px rgba(79,195,247,0.5)"
                        : "none",

                    "&.Mui-selected": {
                      color: "#fff !important", // 🔥 THIS FIXES YOUR ISSUE
                      background: "linear-gradient(135deg, #4fc3f7, #0288d1)",
                      boxShadow: "0 8px 25px rgba(79,195,247,0.5)",
                    },

                    "&:hover": {
                      color: "#fff",
                      background:
                        tab === index
                          ? "linear-gradient(135deg, #4fc3f7, #0288d1)"
                          : "rgba(255,255,255,0.08)",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>
        </Box>

        {/* ================= COACHING ================= */}
        {tab === 0 && (
          <Grid container spacing={8} 
          sx={{
            px:{xs:"auto",lg:8}
          }}
          >
            {coachingServices.map((s, i) => (
              <Grid item xs={12} md={6} key={i}>

                <Card
                  sx={{
                    position: "relative",
                    overflow: "hidden",

                    borderRadius: "22px",
                    height: "300px",

                    backdropFilter: "blur(18px)",

                    background:
                      "linear-gradient(145deg, rgba(255,255,255,0.12), rgba(255,255,255,0.04))",

                    border: "1px solid rgba(255,255,255,0.2)",
                    boxShadow: "0 10px 50px rgba(0,0,0,0.5)",
                  }}
                >
                  {/* 🔥 FULL WATERMARK */}
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,

                      backgroundImage:
                        i === 0
                          ? `url("${Homeimages.rwsignlogo}")`
                          : `url("${Homeimages.rwsignlogo}")`,

                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "250px",

                      opacity: 0.06, // 👈 subtle premium feel
                      // transform: "rotate(-20deg) scale(1.5)",

                      zIndex: 1,
                      pointerEvents: "none",
                    }}
                  />
                  <CardContent
                    sx={{
                      position: "relative",
                      zIndex: 2, // 🔥 important
                      p: 4,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* ICON */}
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "linear-gradient(135deg, #4fc3f7, #0288d1)",
                        mb: 1,
                      }}
                    >
                      <BoltIcon sx={{ color: "#fff" }} />
                    </Box>

                    {/* TITLE */}
                    <Box sx={{ minHeight: "50px" }}>
                      <Typography
                        sx={{
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: 18,
                        }}
                      >
                        {s.title}
                      </Typography>
                    </Box>

                    {/* DESC */}
                    <Box 
                    // sx={{ minHeight: "100px" }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "rgba(255,255,255,0.85)",
                          mt: 1,
                        }}
                      >
                        {s.desc}
                      </Typography>
                    </Box>

                    {/* TAG AT SAME LINE */}
                    <Box
                    // sx={{ mt: "auto" }}
                    >
                      <Divider
                        sx={{
                          borderColor: "rgba(255,255,255,0.2)",
                          // my: 2,
                          mt:4,
                          mb:2

                        }}
                      />

                      <Typography
                        variant="caption"
                        sx={{
                          color: "#fff",
                          fontWeight: 700,
                          letterSpacing: 1.2,
                          textTransform: "uppercase",
                         
                        }}
                      >
                        {s.tag}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        {/* ================= CONSULTING (FLOW) ================= */}
        {tab === 1 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center", // ✅ CENTER on mobile
              justifyContent: "center",
              gap: 2,
            }}
          >
            {consultingSteps.map((step, index) => (
              <React.Fragment key={index}>

                {/* STEP CARD */}
                <Box
                  sx={{
                    width: isMobile ? "90%" : 220, // ✅ CENTER WIDTH
                    maxWidth: 400, // optional for better look
                    minHeight: isMobile ? "auto" : 170,

                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",

                    borderRadius: "26px",
                    p: 2,

                    backdropFilter: "blur(14px)",
                    background:
                      "linear-gradient(160deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05))",
                    border: "1px solid rgba(255,255,255,0.25)",

                    boxShadow: `
              0 10px 30px rgba(0,0,0,0.25),
              0 25px 60px rgba(0,0,0,0.3)
            `,
                  }}
                >
                  {/* CONTENT WRAPPER */}
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: 14,
                        mb: 1,
                        fontFamily: '"Playfair Display", serif !important',
                        textAlign: 'start',
                        color: "#fff",
                      }}
                    >
                      {step.num}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        fontFamily: '"Playfair Display", serif !important',

                        // fontSize: 18,
                        color: "#fff",

                        minHeight: { xs: "auto", md: "42px" }, // ✅ KEY FIX (align descriptions)
                        display: "flex",
                        alignItems: "flex-start",
                        textAlign: 'start',
                      }}
                    >
                      <b>{step.title}</b>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        opacity: 0.85,
                        mt: 1,
                        textAlign: 'start',
                        // fontSize: 14,
                        color: "#fff",
                      }}
                    >
                      {step.desc}
                    </Typography>
                  </Box>
                </Box>

                {/* ARROW */}
                {index !== consultingSteps.length - 1 &&
                  (isMobile ? (
                    <ArrowDownwardIcon
                      sx={{ fontSize: 28, color: "#fff", my: 1 }}
                    />
                  ) : (
                    <ArrowForwardIcon
                      sx={{
                        fontSize: 28,
                        color: "#fff",
                        alignSelf: "center",
                      }}
                    />
                  ))}
              </React.Fragment>
            ))}
          </Box>
        )}

      </Container>
    </Box>
  );
};

export default LuxuryServices;